import React from "react";
import LoginForm from "./LoginForm";
import useLoginForm from "./useLoginForm";

const Login = () => {
  const formProps = useLoginForm();

  return <LoginForm {...formProps} />;
};

export default Login;
